import React, { Component } from "react";
import { slackMessage } from "apis";
import Button from "@material-ui/core/Button";
import * as styles from "../../pages/newStyles.styles";
import { css } from "react-emotion";

const contactInput = css`
  padding: 5px;
  width: 100%;
  border: 1px solid #89d2d3;
  border-radius: 4px;
  font-size: 1em;
  margin-bottom: 10px;
  ::placeholder {
    color: #89d2d3;
    opacity: 1;
  }
`;
const mdcButtonContact = css`
  width: 80px;
`;
const buttonContainerContact = css`
  text-align: right;
`;
const mdcButtonLabelFree = css`
  font-size: 12px;
  color: white;
`;
class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      message: "",
      messageSent: false,
      buttonText: "Send",
    };

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleMessageChange = this.handleMessageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeButtonText = this.changeButtonText.bind(this);
  }

  changeButtonText = (text) => {
    this.setState({
      buttonText: text,
    });
  };

  handleNameChange = (event) => {
    this.setState({
      name: event.target.value,
    });
  };
  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value,
    });
  };
  handlePhoneChange = (event) => {
    this.setState({
      phone: event.target.value,
    });
  };
  handleMessageChange = (event) => {
    this.setState({
      message: event.target.value,
    });
  };

  handleSubmit(event) {
    if (!this.state.messageSent) {
      slackMessage(
        this.state.name,
        this.state.email,
        this.state.phone,
        this.state.message
      );
      this.setState({
        messageSent: true,
      });
      this.changeButtonText("Sent!");
    }
    event.preventDefault();
  }

  render() {
    const { name, email, phone, message, buttonText, messageSent } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <input
          className={contactInput}
          type="text"
          name="name"
          onChange={this.handleNameChange}
          onBlur={this.handleNameChange}
          value={name}
          required
          placeholder="Name"
        />
        <br />
        <input
          className={contactInput}
          type="email"
          name="email"
          onChange={this.handleEmailChange}
          onBlur={this.handleEmailChange}
          value={email}
          required
          placeholder="Email"
        />
        <br />
        <input
          className={contactInput}
          type="tel"
          name="phone"
          onChange={this.handlePhoneChange}
          onBlur={this.handlePhoneChange}
          value={phone}
          required
          placeholder="Phone"
        />
        <br />
        <textarea
          className={contactInput}
          rows="4"
          cols="50"
          onChange={this.handleMessageChange}
          onBlur={this.handleMessgeChange}
          form="usrform"
          value={message}
          required
          placeholder="Message"
        />
        <div className={buttonContainerContact}>
          <Button
            color="secondary"
            variant="contained"
            type="submit"
            className={styles.mdcButton + " " + mdcButtonContact}
          >
            <span className={mdcButtonLabelFree}>
              <a
                style={{
                  color: "inherit",
                  textTranform: "uppercase",
                  textDecoration: "none",
                }}
              >
                {buttonText}
              </a>
            </span>
          </Button>
        </div>
      </form>
    );
  }
}

export default ContactForm;
